import { Screen } from '~/screens/InternalNews/new';

export const InternalNewsNew: React.FC = () => <Screen />;
